module.exports = __webpack_public_path__ + "img/line_img2.9c47679e.png";